import { Tab } from '../../../../../modals/modifier/ModifierModal';

export default {
  title: 'Uusi muokkain',
  tabs: {
    [Tab.General]: 'Yleiset',
    [Tab.NutritionInfo]: 'Ravintotiedot',
  },
  form: {
    modifier_groups: {
      label: 'Kuuluu muokkainryhmiin',
    },
    name: {
      label: 'Nimi',
      placeholder: 'Ketsuppi',
    },
    external_id: {
      label: '{{integration}}-viite',
      placeholder: 'esim. HubRise SKU -viite',
      read_only_hint:
        'Muokattavissa vain, kun HubRise-integraatio on yhdistetty ja valikon synkronointi on pois päältä.',
    },
    price: {
      label: 'Perushinta',
      placeholder: 'Valinnainen',
    },
    is_available: {
      label: 'Varastossa',
    },
    is_visible: {
      label: 'Näkyvissä',
      title: 'Näkyvissä valikossa',
      subtitle_on: 'Asiakkaat näkevät tämän vaihtoehdon',
      subtitle_off: 'Piilotettu kaikilta asiakkailta',
    },
    is_available_for_pickup: {
      label: 'Saatavilla noutoon',
      subtitle_on: 'Asiakkaat voivat tilata sen noutoon',
      subtitle_off: 'Piilotettu nouto­valikosta',
    },
    is_available_for_delivery: {
      label: 'Saatavilla toimitukseen',
      subtitle_on: 'Asiakkaat voivat tilata sen toimitukseen',
      subtitle_off: 'Piilotettu toimitusvalikosta',
    },
  },
  availability: {
    title: 'Saatavuus',
    helper:
      'Näkyvyys on pääkytkin. Poista kanava käytöstä piilottaaksesi tämän vaihtoehdon nouto- tai toimitusasiakkailta poistamatta sitä valikosta.',
    status: {
      both: 'Molemmat kanavat',
      pickup_only: 'Vain nouto',
      delivery_only: 'Vain toimitus',
      hidden: 'Piilotettu',
      no_channels: 'Ei kanavia',
    },
    warning: {
      no_channels:
        'Tämä vaihtoehto on näkyvissä, mutta saatavilla ei yhdessäkään kanavassa — asiakkaat eivät voi valita sitä.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Vain nouto',
      delivery_only: 'Vain toimitus',
      no_channels: 'Ei kanavia',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    changes_got_saved: 'Muutokset tallennettu onnistuneesti!',
  },
};
